import { channel as defaultChannel } from "../config/index";

// TikTok Pixel 上报模块（仅在 channel 以 536_tk 开头的 TikTok 渠道启用）：
// 动态加载官方 base code，队列机制保证脚本加载完成前入队的事件不丢；
// 全部 try/catch 吞错，像素异常不影响业务流程

const TIKTOK_PIXEL_ID = "DBC8SDBC77U9IVCSQ9SG";
// TikTok 渠道前缀：channel 以此开头走 TikTok 像素，否则走 Facebook 像素
const TIKTOK_CHANNEL_PREFIX = "536_tk";

let loadStarted = false;

// 当前渠道：URL query 的 channel 优先，其次本地缓存，都没有用默认值（h5）
export const getChannel = () => {
  try {
    const queryChannel = new URLSearchParams(window.location.search).get("channel");
    return (queryChannel || localStorage.getItem("channel") || defaultChannel || "").trim();
  } catch (e) {
    return String(defaultChannel || "");
  }
};

// 是否 TikTok 渠道（channel 以 536_tk 开头）
export const isTiktokChannel = () => getChannel().indexOf(TIKTOK_CHANNEL_PREFIX) === 0;

// TikTok Pixel 官方 base code（改写为函数式动态加载，重复调用安全）
const loadTiktokPixel = () => {
  if (loadStarted) return;
  loadStarted = true;
  // eslint-disable-next-line
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = [
      "page",
      "track",
      "identify",
      "instances",
      "debug",
      "on",
      "off",
      "once",
      "ready",
      "alias",
      "group",
      "enableCookie",
      "disableCookie",
    ];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = i;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var o = d.createElement("script");
      o.type = "text/javascript";
      o.async = !0;
      o.src = i + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(o, a);
    };
    ttq.load(TIKTOK_PIXEL_ID);
    ttq.page();
  })(window, document, "ttq");
};

// 应用启动时初始化（TikTok 渠道调用），幂等：加载基础代码并发 Pageview
export function initTiktokPixel() {
  try {
    if (!isTiktokChannel()) return;
    console.log("[TiktokPixel] init, channel:", getChannel());
    loadTiktokPixel();
  } catch (e) {}
}

// 上报事件：TikTok 渠道才发送，vconsole 打印名称和参数（非 TikTok 渠道直接跳过，不打日志避免误导）
export function trackTiktokEvent(eventName, params) {
  try {
    if (!isTiktokChannel()) return;
    loadTiktokPixel();
    if (window.ttq) {
      console.log("[TiktokPixel] track:", eventName, params || {});
      window.ttq.track(eventName, params || {}, {
        event_id: params && params.event_id ? String(params.event_id) : undefined,
      });
    }
  } catch (e) {}
}

// 匿名注册成功（对应 Meta 的 Lead）：event_id 为用户 id（取不到时不带该字段）
export function reportTiktokRegistration(userId) {
  const params = {};
  if (userId) {
    params.event_id = String(userId);
  }
  trackTiktokEvent("CompleteRegistration", params);
}

// 支付完成（Purchase）：直接传档位对象，content_id 取 tier_id（vip）或 type（非 vip）；
// event_id 为订单 id（取不到时不带该字段）
export function reportTiktokPayment(value, item, orderId) {
  const params = {
    content_type: "product",
    quantity: 1,
    content_id: String((item && (item.tier_id || item.type)) || ""),
    currency: "USD",
    value: Number(value) || 0,
  };
  if (orderId) {
    params.event_id = String(orderId);
  }
  trackTiktokEvent("Purchase", params);
}

// VIP 订阅支付成功（Subscribe）：直接传档位对象（getUnlockPayConfig/getRetentionConfig 的档位），
// content_id 是 tier_id、content_name 是档位 name、description 是 vip_desc；value === price，num_items 固定 1；
// event_id 为订单 id（取不到时不带该字段）
export function reportTiktokSubscribe(value, item, orderId) {
  const params = {
    content_id: String((item && item.tier_id) || ""),
    content_name: (item && item.name) || "",
    content_type: "product",
    currency: "USD",
    description: (item && item.vip_desc) || "",
    price: Number(value) || 0,
    value: Number(value) || 0,
    num_items: 1,
  };
  if (orderId) {
    params.event_id = String(orderId);
  }
  trackTiktokEvent("Subscribe", params);
}
